export default "__VITE_PUBLIC_ASSET__6e4f9ae1__"